export default "__VITE_ASSET__BKOdZBXY__"